<script setup>
import { computed } from 'vue'
import SiteFooter from '../components/layout/SiteFooter.vue'
import SiteHeader from '../components/layout/SiteHeader.vue'
import { appConfig } from '../utils/config'

const manualPdfUrl = computed(() => appConfig.manualPdfUrl)
</script>

<template>
  <div class="manual-page">
    <SiteHeader />

    <main id="main-content" class="manual-main">
      <div class="manual-viewer">
        <iframe
          class="manual-viewer__frame"
          :src="manualPdfUrl"
          title="CIPOPO 电子说明书"
        />
        <p class="manual-viewer__fallback">
          若页面无法正常显示，请
          <a :href="manualPdfUrl" target="_blank" rel="noopener noreferrer">在新窗口打开</a>
          或下载 PDF 查看。
        </p>
      </div>
    </main>

    <SiteFooter />
  </div>
</template>

<style scoped>
.manual-page {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background: #ffffff;
}

.manual-main {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.manual-viewer {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  padding: 0 clamp(20px, 5vw, 48px) clamp(20px, 4vw, 32px);
}

.manual-viewer__frame {
  flex: 1;
  width: 100%;
  min-height: clamp(480px, 72vh, 900px);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: #f7f7f5;
}

.manual-viewer__fallback {
  margin: 12px 0 0;
  color: rgba(0, 0, 0, 0.56);
  font-size: 13px;
  line-height: 1.6;
  text-align: center;
}

.manual-viewer__fallback a {
  color: #000000;
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
